module.exports = __webpack_public_path__ + "static/media/LibraryPanel.1b189fc8.png";